export default __webpack_public_path__ + "static/media/graduationdiploma.fd0910bf.jpg";